import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/logo.svg';
import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';
import './PaymentSuccessPage.scss';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-page-wrapper">
      <SEO {...getRouteMeta('/payment/success')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />

      <div className="payment-success-page">
        <div className="container">
              <div className="success-container">
                <div className="success-animation">
                  <div className="success-icon-wrapper">
                    <div className="success-circle">
                      <svg
                        className="success-checkmark"
                        viewBox="0 0 52 52"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          className="success-circle-path"
                          cx="26"
                          cy="26"
                          r="25"
                          fill="none"
                        />
                        <path
                          className="success-checkmark-path"
                          fill="none"
                          d="M14.1 27.2l7.1 7.2 16.7-16.8"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

            <h1>¡Pago Realizado con Éxito!</h1>
            <p className="success-message">
              Tu reserva ha sido confirmada correctamente. Te hemos enviado un
              correo electrónico con todos los detalles de tu cita y el enlace
              de la videollamada.
            </p>

            <div className="success-details">
              <div className="detail-item">
                <span className="detail-icon">📧</span>
                <div className="detail-content">
                  <h3>Revisa tu correo</h3>
                  <p>
                    Hemos enviado la confirmación a tu email con todos los
                    detalles.
                  </p>
                </div>
              </div>

              <div className="detail-item">
                <span className="detail-icon">📅</span>
                <div className="detail-content">
                  <h3>Agrega a tu calendario</h3>
                  <p>
                    No olvides agregar la cita a tu calendario para no perderla.
                  </p>
                </div>
              </div>

              <div className="detail-item">
                <span className="detail-icon">💬</span>
                <div className="detail-content">
                  <h3>¿Necesitas ayuda?</h3>
                  <p>Si tienes alguna pregunta, no dudes en contactarnos.</p>
                </div>
              </div>
            </div>

            <div className="success-actions">
              <button className="btn-primary" onClick={() => navigate('/')}>
                Volver al Inicio
              </button>
              <button
                className="btn-secondary"
                onClick={() => navigate('/contacto')}
              >
                Contactarnos
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <Scrollbar />
    </div>
  );
};

export default PaymentSuccessPage;
